export default "__VITE_ASSET__C3ozCfKQ__"